var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"holder",style:({
    borderTop: _vm.borderStyle,
    height: _vm.holderSize,
    width: _vm.holderSize,
  })},[_c('div',{staticClass:"dot",style:({ background: _vm.dotStyle })})])}
var staticRenderFns = []

export { render, staticRenderFns }